import React, { useEffect, useState } from 'react';
import SelectBox from 'devextreme-react/select-box';
import { makeStyles } from '@material-ui/core/styles';
import { SmsFormTypeIds, SmsFormTypes } from '../../../Constantes/smsFormTypes';
import { EmailForm } from './EmailForm';
import SmsForm from './SmsForm';
import { FormActionButtons } from '../factoryCaseForm/FormActionButtons';
import { InputWrapper } from '../factoryCaseForm/InputWrapper';
import { useDispatch, useSelector } from 'react-redux';
import { selectTemplateTypes } from '../../../redux/templates/selectors';
import { getTemplateTypes } from '../../../redux/templates/thunks';

const useStyles = makeStyles({

    label: {
        color: "#eeeeee"
    },
    controlers: {
        width:"100% !important"
    },
    containers: {
        marginBottom:10,
    },
    hideSmsContainer: {
        display:"none"
    }
  });

export default function MessageForm (props) {
    
    const classes = useStyles();
    const [formType, setFormType] = useState(SmsFormTypes.default);
    const dispatch = useDispatch();
    const formTypes = useSelector(selectTemplateTypes);

    useEffect(()=>{
        dispatch(getTemplateTypes())
    },[])


    function getTemplatesByType(type){
        let templates = [... props.templates]
        if(type === SmsFormTypes.email){
            templates = templates.filter(template => template.templateTypeId === SmsFormTypeIds.internal_email)
        }     
        if (type === SmsFormTypes.sms) {
            templates = templates.filter(template => template.templateTypeId === SmsFormTypeIds.sms)
        }
        if (type === SmsFormTypes.email_customer) {
            templates = templates.filter(template => template.templateTypeId === SmsFormTypeIds.external_email)
        }
        return templates
    }

    function handleChangeType(value){
        setFormType(value)
        props.handleTemplateChange()
    }

    function handleSubmit(){
        if(formType === SmsFormTypes.sms){
            props.handleSendSmsForm()
        }     
        if (formType === SmsFormTypes.email || formType === SmsFormTypes.email_customer ) {
            props.handleSendEmailForm(formType === SmsFormTypes.email)
        }
    }

    return (<div className={props.showMessageForm ? "case-header-form" : classes.hideSmsContainer} style={{position:"absolute",top:0,zIndex:1500,right:0,width:"280px",height:"auto",backgroundColor:"#3B5158",padding:"15px"}}>   
                <div className={classes.containers}>
                    <InputWrapper label={"Tipo"} labelColor={"#eeeeee"}>
                        <SelectBox value={formType} onValueChange={handleChangeType} placeholder="" dataSource={formTypes?.filter(to => to.code !== 'custom_email')} displayExpr={"description"} valueExpr={"code"} height={25} ></SelectBox>
                    </InputWrapper>
                </div>
                {formType === SmsFormTypes.email &&
                    <EmailForm {...props} dataForm={props.dataEmailForm} templates={getTemplatesByType(SmsFormTypes.email)} formType={formType}/>
                }
                {formType === SmsFormTypes.email_customer &&
                    <EmailForm {...props} dataForm={props.dataEmailForm} templates={getTemplatesByType(SmsFormTypes.email_customer)} formType={formType}/>
                }
                {formType === SmsFormTypes.sms  &&
                    <SmsForm {...props} dataForm={props.dataSMSForm} templates={getTemplatesByType(SmsFormTypes.sms)}/> 
                }
                <FormActionButtons
                    cancelFunction={() => props.handleShowForms(formType)}
                    submitFunction={()=> handleSubmit()}
                    submitText={"Enviar"}
                    disabled={props.disabledSms}
                />   
            </div>);
}